// NOTE: Dependencies: jQuery, defiant, MarkerClusterer

(function ($) {
	$.fn.lmSearchResultsMap = function(options) {
		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			toggleBtn: '.map-toggle',
			details: '.search-results__details',
			toggleClass: 'search-results--details-hide',
			searchResultsItem: '.search-results__item',
			searchResultsItemActive: 'search-results__item--active',
			activeSearchContent: [],
			$searchInput: $('#searchInput'),
			$countrySelect: $('#countrySelect'),
			$searchForm: $('#searchForm'),
			$headerMap: $('#headerMap'),
			$header: $('#header'),
			headerClass: 'header--map',
			$locationButton: $('#headerLocation'),
			mapSearchRadius: 0.4,
			searchUrl: 'search-results/',
			firstLoad: true,
			isVisible: true,
			headerMapActiveClass: 'header-map--active',
			$body: $('body'),
			icon: {
				url: '/assets/images/map-icon.png',
				scaledSize: new google.maps.Size(60,75),
				'optimized': false
			},
			iconActive: {
				url: '/assets/images/map-icon-active.png',
				scaledSize: new google.maps.Size(80,100),
				zIndex: 99999999,
				'optimized': false
			}
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function($context) {

			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
			settings.$details = $context.parent();
			settings.geoLocation = $context.data('geolocation');
			settings.searchResults = $context.data('search-results');
			settings.$searchItems = $('#searchItems');
			settings.zoomLevel = $context.data('zoom');
			settings.country = settings.$body.data('country');
			settings.countryQuery = {country: settings.country}
			settings.fullDetailsLabel = settings.$body.data('full-details');
			settings.getDirectionsLabel = settings.$body.data('get-directions');
			settings.noResultsMessage = settings.$body.data('no-results');
			$.fn.lmGlobal.checkPlatform(settings);

			if (settings.$headerMap.length) {
				var headerMapPos = parseInt($('#headerMap').css('transform').split(',')[5]);

				settings.isVisible = headerMapPos !== 0 ? false : true;
			}
		}

		// Bind events
		methods.events = function($context) {

			// Click event for location close to toggle markers and close panel.
			$context.parent().find(settings.toggleBtn).off('click.lmSearchResultsMap').on('click.lmSearchResultsMap', function(event) {
				event.preventDefault();

				settings.$details.toggleClass(settings.toggleClass);
			});

			// Location button for geolocation
			settings.$locationButton.off('click.lmHeaderMap').on('click.lmHeaderMap', function(event) {
				event.preventDefault();
				methods.toggleHeader($context);
			});

			// Click event for location close to toggle markers and close panel.
			//$(document.body).on('click', settings.searchResultsItem, function(event) {
			$(document.body).off('click.lmSearchResultsMap').on('click.lmSearchResultsMap', settings.searchResultsItem + ':not(#noResults)',  function(event) {
				event.preventDefault();
				var $this = $(this);

				// Re-center map
				settings.$details.addClass('search-results--off-centre');

				$(settings.searchResultsItem).removeClass('search-results__item--active');
				$this.addClass(settings.searchResultsItemActive);

				settings.map.setCenter({lat: parseFloat($this.data('lat')), lng: parseFloat($this.data('long'))});

				// Add active marker
				for (var j = 0; j < settings.googleMapMarkers.length; j++) {

					if (settings.googleMapMarkers[j].id == $this.attr('id')) {
						settings.googleMapMarkers[j].setIcon(settings.iconActive);
					} else {
						settings.googleMapMarkers[j].setIcon(settings.icon);
					}
				}
			});

			$(document.body).on('click', '.search-results__directions', function(event) {
				event.stopPropagation();
			});

			$(document.body).on('click', '.button', function(event) {
				event.stopPropagation();
			});

			// Form submit function
			settings.$searchForm.off('submit.lmSearchResultsMap').on('submit.lmSearchResultsMap', function(event) {
				event.preventDefault();
				// Setting to false so can run normal post search functions
				settings.searchValue = settings.$searchInput.val();
				settings.countryValue = settings.$countrySelect.val();
				$.fn.lmGlobal.searchJson(settings);
			});
		}

		// Toggle Active Classes
		methods.toggleHeader = function ($context) {
			settings.$headerMap.toggleClass(settings.headerMapActiveClass);
			settings.$header.toggleClass(settings.headerClass);

			if (settings.firstLoad && settings.$headerMap.hasClass(settings.headerMapActiveClass)) {
				settings.isVisible = true;
				methods.initContext($context);
			}
		}

		// On load function.
		methods.initContext = function ($context) {

			if (settings.geoLocation && settings.isVisible) {

				// Call GeoLocation
				methods.geoLocation($context);
			} else if (settings.isVisible) {

				settings.locationAreaLat = parseFloat(methods.getQueryVariable('latitude'));
				settings.locationAreaLng = parseFloat(methods.getQueryVariable('longitude'));
				settings.searchValue = methods.getQueryVariable('value');

				$.ajax({
					type: 'GET',
					dataType: 'json',
					data: settings.countryQuery,
					url: settings.locationJsonUrl,
					success: function(data, textStatus, jqXHR) {
						settings.mapMarkers = data.Markers;
						settings.dataSnapShot = defiant.getSnapshot(data);

						var searchValue = '',
								addressString = '';

						if (settings.searchValue) {
							searchValue = settings.searchValue.trim().replace(' ', '+');
						}


						if(settings.countryValue) {
							var countryValue = settings.countryValue;
						} else {
							var countryValue = settings.$body.data('country');
						}

						countryValue ? addressString = searchValue + '+' + countryValue : addressString = searchValue;



						var	data = {
							address: searchValue,
							country: countryValue
						}

						// console.log(data);

						if (settings.searchValue) {

							methods.searchLocalJSON($context, data);

						} else {
							settings.zoomLevel = 7,
							settings.locationAreaLat = parseFloat($context.data('location-area').lat),
							settings.locationAreaLng = parseFloat($context.data('location-area').lng);
							methods.noResults($context);
							methods.setMap($context);
						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						// TODO error handling
					}
				});

			}
		}

		methods.captilise = function(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		methods.searchLocalJSON = function($context, data) {

			var result = defiant.json.search(settings.dataSnapShot, '//*[City="'+ settings.searchValue.toUpperCase() +'"]');

			if (!result.length) {
				settings.searchValue = methods.captilise(settings.searchValue);
				result = defiant.json.search(settings.dataSnapShot, '//*[Name="'+ settings.searchValue +'"]');
			}

			if (!result.length) {
				result = defiant.json.search(settings.dataSnapShot, "//*[contains(City, '"+ settings.searchValue +"')]");
			}

			if (!result.length) {
				result = defiant.json.search(settings.dataSnapShot, "//*[contains(Name, '"+ settings.searchValue +"')]");
			}

			if (result.length) {
				settings.locationAreaLat = parseFloat(result[0].Latitude),
				settings.locationAreaLng = parseFloat(result[0].Longitude),
				settings.zoomLevel = $context.data('zoom');

				methods.setMap($context);
			} else {
				methods.googleGeo($context, data);
			}

		}

		methods.googleGeo = function($context, data) {
			$.ajax({
				type: 'GET',
				dataType: 'json',
				data: data,
				url: settings.googleGeoCodeUrl,
				success: function(data, textStatus, jqXHR) {
					if (data.results[0]) {

						// Finding lat and long from search result from google geocoding API. Then creating a radius to search.
						var latArea = data.results[0].geometry.location.lat,
								lngArea = data.results[0].geometry.location.lng,
								latLowRange = latArea - settings.mapSearchRadius,
								latHighRange = latArea + settings.mapSearchRadius,
								lngLowRange = lngArea - settings.mapSearchRadius,
								lngHighRange = lngArea + settings.mapSearchRadius;

						//console.log('Map Search' + settings.mapSearchRadius);

						// Defaults set.
						settings.locationAreaLat = parseFloat(latArea),
						settings.locationAreaLng = parseFloat(lngArea),
						settings.zoomLevel = $context.data('zoom');

						methods.setMap($context);
					} else {
						settings.zoomLevel = 7,
						settings.locationAreaLat = parseFloat($context.data('location-area').lat),
						settings.locationAreaLng = parseFloat($context.data('location-area').lng);
						methods.noResults($context);
						methods.setMap($context);
					}
				},
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		}

		// Run once methods when jquery plugin is called.
		methods.events(this);

		methods.getQueryVariable = function(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
				var pair = vars[i].split("=");
				if(pair[0] == variable){return pair[1];}
			}
			return(false);
		}

		// Set map with custom silver JSON colour.
		methods.setMap = function($context) {

			settings.map = new google.maps.Map($context[0], {
				center: {
					lat: settings.locationAreaLat,
					lng: settings.locationAreaLng
				},
				scrollwheel: false,
				zoom: settings.zoomLevel,
				zoomControl: true,
				styles: [
					{
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"elementType": "labels.text.stroke",
						"stylers": [
							{
								"color": "#f5f5f5"
							}
						]
					},
					{
						"featureType": "administrative.land_parcel",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#bdbdbd"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "poi.park",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#ffffff"
							}
						]
					},
					{
						"featureType": "road.arterial",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#757575"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#dadada"
							}
						]
					},
					{
						"featureType": "road.highway",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#616161"
							}
						]
					},
					{
						"featureType": "road.local",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					},
					{
						"featureType": "transit.line",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#e5e5e5"
							}
						]
					},
					{
						"featureType": "transit.station",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#eeeeee"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "geometry",
						"stylers": [
							{
								"color": "#c9c9c9"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"color": "#9e9e9e"
							}
						]
					}
				]
			});

			// Idle event is once a zoom or pan event or page load of map is complete
			google.maps.event.addDomListener(settings.map, 'idle', function($context){

				// Resetting context as becomes undefined in idle function
				$context = $('.search-results__map');

				// Setting location marker or loading all markers
				if (settings.firstLoad) {
					methods.ajaxCheck($context);
				} else {
					methods.mapStatusCheck($context);
				}

				// commenting out until happy with bug fix
				//settings.$details.removeClass('search-results--off-centre');
			});

			// Had to separate out into two events because of error on load when just using idle
			google.maps.event.addDomListener(settings.map, 'tilesloaded', function($context){

				settings.$details.addClass('search-results--active');
			});

			// Resize map event
			google.maps.event.addDomListener(window, 'resize', function($context) {

				if ($('#searchItems').length) {
					var firstItem = $('#searchItems').children().first(),
							centreId = firstItem.attr('id');

					if (centreId != 'noResults') {
						var lat = firstItem.data('lat'),
								long = firstItem.data('long');

						settings.$details.addClass('search-results--off-centre');
						settings.map.setCenter({lat: lat, lng: long});
					}
				}
			});

		}

		methods.mapStatusCheck = function($context) {

			// Do multiple checks to decide once all markers have been initialised
			if ((!methods.getQueryVariable('value') || isNaN(settings.locationAreaLat) || isNaN(settings.locationAreaLng)) && settings.firstLoad && !settings.geoLocation) {

				// No results
				methods.noResults($context);
			} else if (!settings.firstLoad) {

				// Call Search results function.
				settings.zoomLevel = settings.map.getZoom();

				methods.checkActiveMarkers($context);
				methods.toggleMarkers($context);
			}
		}

		// Search. Check which markers are in the viewport.
		methods.checkActiveMarkers = function($context) {
			settings.activeMarkerIds = [];

			var activeArray = [],
					centrePosition = {};

			// Rewriting all this so the array orders by nearest the centre of the map
			// Get centre position
			centrePosition = {position: {
				lat: settings.map.getCenter().lat(),
				lng: settings.map.getCenter().lng()
			}}

			// Loop through and create a local var array of markers on map with the ID and distance from centre in an object
			settings.googleMapMarkers.forEach(function (value) {
				if( settings.map.getBounds().contains(value.getPosition()) ){
					activeArray.push({
						id: value.get('id'),
						distance: methods.distanceCalc(centrePosition.position.lat, centrePosition.position.lng, value.position.lat(), value.position.lng())
					});
				}
			})

			// Sort by distance lowest to highest
			activeArray.sort(function(a, b){
				return a.distance-b.distance;
			});

			// Delete the distance
			activeArray = activeArray.filter(function (props) {
				delete props.distance;
				return true;
			});

			// Convert one item object array to standard array
			// Set global var to new ordered array
			settings.activeMarkerIds = $.map(activeArray, function(value, index) {
				return [value.id];
			});

			methods.activeSearchContent($context);
		}

		methods.distanceCalc = function(lat1, lon1, lat2, lon2) {
			var radlat1 = Math.PI * lat1/180,
					radlat2 = Math.PI * lat2/180,
					theta = lon1-lon2,
					radtheta = Math.PI * theta/180,
					dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
					dist = Math.acos(dist);
					dist = dist * 180/Math.PI;
					dist = dist * 60 * 1.1515;
			return dist;
		}

		methods.noResults = function($context) {

			// No results
			var html = `<div class="search-results__item search-results__item--active search-results__item--no-results" id="noResults"><div class="grid grid--nowrap-all"><div class="grid__item grid__item--columns-12 grid__item--no-internal-grid"><div class="search-results__description">${settings.noResultsMessage}</div></div></div></div>`;

			// Add HTML
			settings.$searchItems.html(html);

			// Reset active search array
			settings.activeSearchContent = [];

			if (settings.zoomLevel !== 7) {

				settings.locationAreaLat = parseFloat($context.data('location-area').lat);
				settings.locationAreaLng = parseFloat($context.data('location-area').lng);

				settings.map.setCenter({lat: settings.locationAreaLat, lng: settings.locationAreaLng});
				settings.map.setZoom(7);
			}
		}

		// Compare active markers to the content on the page and amend as necessary. Rather than loading entire content set.
		methods.activeSearchContent = function($context) {

			if(!settings.activeMarkerIds.length || settings.zoomLevel < 9) {

				// No Results
				methods.noResults($context);
			} else {

				// Removing no results item if markers
				$('#noResults').remove();
			}

			// If statement figures out the differences between the markers loaded in the map and what content is in the left panel and amends accordingly.noResults
			if(settings.activeSearchContent.length && settings.zoomLevel > 8 && (settings.$searchItems.html() != '' || settings.$searchItems.find('#noResults').length)) {

				// Content difference
				var removeDifference = settings.activeSearchContent.filter(x => settings.activeMarkerIds.indexOf(x) == -1),
						addDifference = settings.activeMarkerIds.filter(x => settings.activeSearchContent.indexOf(x) == -1);

				// Remove function
				for (var i=0; i < removeDifference.length; i++){
					var id = removeDifference[i];
					methods.removeResult($context, id);
				}

				// Add function
				for (var i=0; i < addDifference.length; i++){
					var id = addDifference[i];
					methods.addResult($context, id, false);
				}

				// Update active Search Content array
				settings.activeSearchContent = settings.activeMarkerIds
			} else if ((!settings.activeSearchContent.length && settings.zoomLevel > 8 && settings.$searchItems.html() == '')) {

				// Initial load or full load.
				for (var i=0; i < settings.activeMarkerIds.length; i++){
					var id = settings.activeMarkerIds[i],
							first = false;

					if (i == 0) {
						first = true;
					}

					methods.addResult($context, id, first);
				}

				// Update active Search Content array
				settings.activeSearchContent = settings.activeMarkerIds
			}


		}

		methods.addResult = function($context, id, first) {
			var className,
					searchResult = defiant.json.search(settings.dataSnapShot,  "//*[contains(Id, '" + id + "')]")[0];

			if (first) {
				className = 'search-results__item ' + settings.searchResultsItemActive;

				// Centre map around first item back from JSON
				settings.map.setCenter({lat: settings.locationAreaLat, lng: settings.locationAreaLng});

				// Set first marker to active
				// Add active marker
				for (var j = 0; j < settings.googleMapMarkers.length; j++) {

					if (settings.googleMapMarkers[j].id == id) {
						settings.googleMapMarkers[j].setIcon(settings.iconActive);
					} else {
						settings.googleMapMarkers[j].setIcon(settings.icon);
					}
				}
			} else {
				className = 'search-results__item';
			}

			var address = searchResult.Address.replace(' ', '+')

			var searchResultHtml = `<div class="${className}" id="${searchResult.Id}" data-lat="${searchResult.Latitude}" data-long="${searchResult.Longitude}"><div class="grid grid--nowrap-all"><div class="grid__item grid__item--columns-6 grid__item--no-internal-grid"><div class="search-results__description">${searchResult.Address}</div></div><div class="grid__item grid__item--columns-3 grid__item--no-internal-grid"><a href="https://maps.google.com?saddr=Current+Location&daddr=${searchResult.Latitude},${searchResult.Longitude}" target="_blank" class="search-results__directions">${settings.getDirectionsLabel}</a></div><div class="grid__item grid__item--columns-3 grid__item--no-internal-grid"><a href="${settings.domain}${searchResult.Url}" class="button button--inverse-alt">${settings.fullDetailsLabel}</a></div></div></div>`;

			// Add HTML
			settings.$searchItems.append(searchResultHtml);
		}

		methods.removeResult = function($context, id) {
			$('#'+id).remove();
		}

		// GeoLocation
		methods.geoLocation = function($context) {

			if (navigator.geolocation) {

				var success = function(pos) {
					var crd = pos.coords;

					settings.locationAreaLat = crd.latitude;
					settings.locationAreaLng = crd.longitude;

					methods.setMap($context);
				};

				var error = function(err) {

					// Else if geolocation not used set defaults with zoomed out value
					settings.locationAreaLat = parseFloat($context.data('location-area').lat);
					settings.locationAreaLng = parseFloat($context.data('location-area').lng);
					settings.zoomLevel = 6;
					settings.geoLocation = false;
					methods.setMap($context);
				};

				navigator.geolocation.getCurrentPosition(success, error);
			} else {
				// Else if geolocation not used set defaults with zoomed out value
				settings.locationAreaLat = parseFloat($context.data('location-area').lat);
				settings.locationAreaLng = parseFloat($context.data('location-area').lng);
				settings.zoomLevel = 6;
				settings.geoLocation = false;
				methods.setMap($context);
			}
		}

		// Ajax Call
		methods.ajaxCheck = function($context) {

			// Check cache
			if (!settings.mapMarkers) {
				$.ajax({
					type: 'GET',
					data: settings.countryQuery,
					dataType: 'json',
					url: settings.locationJsonUrl,
					success: function(data, textStatus, jqXHR) {
						settings.mapMarkers = data.Markers;
						settings.dataSnapShot = defiant.getSnapshot(data);
						methods.setAllLocations($context);
					}
				});
			} else {
				// Cache
				methods.setAllLocations($context);
			}
		}

		methods.setAllLocations = function($context) {
			settings.googleMapMarkers = [];
			settings.googleMapInfoWindows = [];

			//setting info window
			var infoWindow = new google.maps.InfoWindow({
				maxWidth: 200
			});

			for (var i = 0; i < settings.mapMarkers.length; i++) {
				var newGmapValue = new google.maps.LatLng(settings.mapMarkers[i].Latitude, settings.mapMarkers[i].Longitude),
						newGmapMarker = new google.maps.Marker({
							position: newGmapValue,
							map: settings.map,
							icon: settings.icon
						})

				// Assign id so marker is searchable
				newGmapMarker.setValues({
					id: settings.mapMarkers[i].Id,
					url: settings.mapMarkers[i].Url
				});

				// Assign contentString to click of marker to display infowindow
				google.maps.event.addListener(newGmapMarker, 'click', (function(newGmapMarker) {
					return function() {
						var marker = this,
								resultItem = $('#' + marker.get('id')),
								markerUrl = marker.get('url');

						$(settings.searchResultsItem).removeClass('search-results__item--active');
						resultItem.addClass('search-results__item--active');

						if (marker.icon.url == settings.iconActive.url) {
							// Redirect to location page for second click on marker
							window.location.href = settings.domain + markerUrl;
						} else {
							// Add active marker
							settings.googleMapMarkers.forEach(function (value) {
								value.setIcon(settings.icon);
							});
							marker.setIcon(settings.iconActive);
						}

						// Scroll panel
						if($(window).width() > 768) {
							var position = resultItem.position().top - $('.search-results__header').outerHeight();
						} else {
							var position = resultItem.position().top;
						}

						$(settings.details).animate({
							scrollTop: position
						}, 500);

					}
				})(newGmapMarker));

				// Pushing markers and infowindow to arrays so can toggle show / hide effectively
				settings.googleMapMarkers.push(newGmapMarker);
				settings.googleMapInfoWindows.push(infoWindow);
			}

			if (settings.firstLoad) {
				methods.checkActiveMarkers($context);
				methods.toggleMarkers($context);
				methods.mapStatusCheck($context);
				settings.firstLoad = false;
			}
		}

		methods.toggleMarkers = function($context) {

			// Toggle Markers
			for (var i = 0; i < settings.googleMapMarkers.length; i++) {
				if(settings.googleMapMarkers[i].getVisible() && settings.zoomLevel < 9) {
					settings.googleMapMarkers[i].setVisible(false);
				}
				else if (!settings.googleMapMarkers[i].getVisible() && settings.zoomLevel > 8) {
					settings.googleMapMarkers[i].setVisible(true);
				}
			}
			// Toggle InfoWindows
			for (var i=0; i < settings.googleMapInfoWindows.length; i++) {
				settings.googleMapInfoWindows[i].close();
			}
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.

			// Set Current Settings
			methods.setCurrentSettings($(this));
			methods.initContext($(this));

		});
	};

	if($('.search-results__map').length) {
		$('.search-results__map').lmSearchResultsMap();
	}

}(jQuery));
